<div class="mp-header">
  <div class="mp-toolbar color-toolbar" style="text-align: center;">
      <div class="mp-toolbar__content">
        <div class="container-header">
          <span style="font-weight: 700;" class="mp-label ion-text-wrap" text-wrap translate>Redirect to WhatsApp</span>
        </div>
      </div>
  </div>
</div>


<div class="center-div-message">
  <p translate>Click the button below to send order to WhatsApp</p>
</div>

<div class="div-redirectWhatsApp">
    <button
        style="font-weight: 800;"
        class="mp-button mp-button--ios mp-button--success mp-button--block ion-text-wrap"
        text-wrap
        (click)="onClick()"
        translate
    >
        <mp-icon name="logo-whatsapp" style="margin-right: 4px;"></mp-icon> Send order to WhatsApp
    </button>
</div>
